import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "CdCreateExchange"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.5 12.0001C11.3284 12.0001 12 11.3285 12 10.5001C12 9.67168 11.3284 9.0001 10.5 9.0001C9.67157 9.0001 9 9.67168 9 10.5001C9 11.3285 9.67157 12.0001 10.5 12.0001ZM10.5 1.50008C5.52944 1.50008 1.5 5.52952 1.5 10.5001C1.5 15.4706 5.52944 19.5001 10.5 19.5001V18.0001C6.35786 18.0001 3 14.6422 3 10.5001C3 6.35794 6.35786 3.00008 10.5 3.00008C14.6421 3.00008 18 6.35794 18 10.5001C18.0151 10.7498 18.0151 11.0003 18 11.2501H19.5C19.5 11.0026 19.5375 10.7551 19.5375 10.5001C19.5375 8.10662 18.5842 5.81173 16.8882 4.12282C15.1923 2.43391 12.8934 1.49011 10.5 1.50008ZM10.5 15.0001C8.01472 15.0001 6 12.9854 6 10.5001C6 8.01482 8.01472 6.0001 10.5 6.0001C12.9853 6.0001 15 8.01482 15 10.5001C15 12.9854 12.9853 15.0001 10.5 15.0001ZM12.75 18.0001H19.6275L17.685 19.9426L18.75 21.0001L22.5 17.2501L18.75 13.5001L17.685 14.5651L19.6275 16.5001H12.75V18.0001ZM7.5 10.5001C7.5 8.84325 8.84315 7.5001 10.5 7.5001C12.1569 7.5001 13.5 8.84325 13.5 10.5001C13.5 12.157 12.1569 13.5001 10.5 13.5001C8.84315 13.5001 7.5 12.157 7.5 10.5001Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/CdCreateExchange.vue"]]);
